// The base look and feel of all Navigation Bar Items
export const NAV_BAR_ITEM_BASE_STYLE = `
    height: 3.67rem;
    padding: 0 1rem;

    display: flex;
    font-size: 1.167rem;
    font-weight: 700;
    align-items: center;

    text-decoration: none;
    cursor: pointer;
    color: white;
    background: #33373d;


    &.active, &:hover.active {
        background: white;
        color: #33373d;
    }

    &:hover {
        color: white;
        background: #676a6e;
    }

    .icon {
        font-size: 1.25rem;
        margin-right: 0.5rem;
    }
`;
// Style rules to apply to a react-router-dom element if using one in the Nav Bar
export const NAV_BAR_ROUTER_LINK_STYLE = `
    && {
        ${NAV_BAR_ITEM_BASE_STYLE}
        flex-direction: row;
        align-items: center;
    }
`;
